// extracted by mini-css-extract-plugin
export default {"customInput":"CustomInput_customInput__-LTLb","label":"CustomInput_label__3H1Uy","input":"CustomInput_input__jvwsu","error":"CustomInput_error__v6nV4"};